import { STATIC_URL } from 'constants/data'
import { RefObject } from 'react'

const imgData = {
  width: 220,
  height: 348,
  src: `${STATIC_URL}/crowd-funding/banner_portraits.png`,
  alt: 'Портреты',
  unoptimized: true,
}

const imgDataWide = {
  width: 431,
  height: 265,
  src: `${STATIC_URL}/crowd-funding/banner_portraits-wide.png`,
  alt: 'Портреты',
  unoptimized: true,
}

const logoData = {
  width: 160,
  height: 30,
  src: `${STATIC_URL}/crowd-funding/top-logo.png`,
  alt: 'лого',
  unoptimized: true,
}

interface ICrowdWebinarBanner {
  isWide?: boolean
  crowdRef?: RefObject<HTMLDivElement>
}

export { imgData, logoData, imgDataWide }
export type { ICrowdWebinarBanner }
